module.exports = __webpack_public_path__ + "img/icon-playlist-folder.d024c955.svg";